<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap"
        :bodyStyle="{ padding: '16px', overflow: 'hidden' }"
        v-model="modalVisible"
        :confirmLoading="loading"
        :maskClosable="false"
        @cancel="cancel"
        @ok="confirm"
    >
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
      <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model
            ref="form"
            :model="form"
            :rules="rules"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item prop="product_id" label="产品名称">
            <a-select
                v-model="form.product_id"
                style="width: 100%"
                :show-search="true"
                :filterOption="false"
                @change="onChange"
                @search="handleProductSearch"
                @popupScroll="handleProductPopupScroll"
            >
              <a-select-option
                  v-for="val in filteredProductList"
                  :key="val.goods.id"
                  :value="val.goods.id"
              >
                {{ val.product_name }} ({{ val.goods.id }})
              </a-select-option>
              <a-select-option v-if="isLoadingMoreProducts" disabled key="loading" value="loading">
                <a-spin size="small" /> 加载中...
              </a-select-option>
              <a-select-option v-if="!hasMoreProducts && allLoadedProducts.length > 0" disabled key="no-more" value="no-more">
                已加载全部 {{ productTotalCount }} 条数据
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="batch" label="生产日期/批次">
            <a-date-picker v-model="form.batch" valueFormat="YYYYMMDD"/>
          </a-form-model-item>
          <!-- <a-form-model-item prop="batch">
            <a-select v-model="form.batch" style="width: 100%">
              <a-select-option
                v-for="(val, index) in batchList.pici"
                :key="index"
                :value="val"
              >
                {{ val }}
              </a-select-option>
            </a-select>
          </a-form-model-item> -->
          <a-form-model-item prop="number" label="编号">
            <a-input v-model="form.number"/>
          </a-form-model-item>
          <!--          multiple改为tags 是为了兼容即可选择，又可输入。-->
          <a-form-model-item prop="title" label="原材料描述">
            <a-select mode="tags" v-model="form.others.describe_y">
              <a-select-option v-for="(val, index) in titleList" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="title" label="生产投料描述">
            <a-select mode="tags" v-model="form.others.describe_s">
              <a-select-option v-for="(val, index) in titleList1" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <div>
            <a-button
                type="primary"
                @click="addNewForm"
                style="margin-bottom: 20px"
            >新增原料信息
            </a-button
            >
            <div v-for="(forms, index) in form.material" :key="'material-' + index">
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <span>状态 </span>
                <a-select v-model="forms.state" style="width: 85%">
                  <a-select-option value="正常"> 正常</a-select-option>
                  <a-select-option value="异常"> 异常</a-select-option>
                </a-select>
                <a-button
                    style="margin-left: 10px"
                    size="small"
                    @click="removeFormItem2(index)"
                >
                  <a-icon type="minus"/>
                </a-button>
              </div>
              名称
              <a-input
                  v-model="forms.product_name"
                  disabled
                  style="width: 85%; margin: 20px 0"
              />
              <br/>
              重量
              <a-input
                  v-model="forms.weight"
                  style="width: 66%; margin-right: 2%"
                  @change="onRefresh"
              />
              <a-select
                  v-model="forms.unit"
                  style="width: 25%"
                  placeholder="单位"
              >
                <a-select-option value="g">g</a-select-option>
                <a-select-option value="kg">kg</a-select-option>
                <a-select-option value="吨">吨</a-select-option>
              </a-select>

              <br/>
              批次
              <a-input
                  v-model="forms.material_batch"
                  style="width: 85%; margin: 20px 0"
                  @change="onRefresh"
              />
              <div style="display: flex; justify-content: left; margin-bottom: 20px;">
                <span style="display: block; width: 18%">检验报告 </span>
                <div style="flex: 1">
                  <a-upload
                      accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                      :action="uploadUrl"
                      :headers="uploadHeaders"
                      :maxCount="5"
                      list-type="picture-card"
                      :file-list="forms.report_img"
                      :before-upload="beforeUploadFile"
                      @change="(fl) => handleChange(fl, index)"
                      name="file"
                      :showUploadList="false"
                  >
                    <div v-if="!forms.report_img || forms.report_img.length < 5">
                      <a-icon type="plus"/>
                      <div class="ant-upload-text"></div>
                    </div>
                  </a-upload>
                  <!-- 自定义卡片列表 -->
                  <div class="file-card-list">
                    <div
                        v-for="(file, fi) in (forms.report_img || [])"
                        :key="file.uid || fi"
                        class="file-card"
                        @click="handlePreview(file)"
                    >
                      <img v-if="isImageFile(file.name || file.url || '')" :src="file.url || file.thumbUrl || (file.response && file.response.data && file.response.data.file_url)" class="file-thumb" />
                      <div v-else class="file-icon-wrap"><span class="file-ext-icon">{{ getExtLabel(file) }}</span></div>
                      <span class="file-badge" :class="getFileBadgeClass(file)">{{ getFileBadgeText(file) }}</span>
                      <div class="file-name">{{ getFileDisplayName(file) }}</div>
                      <a-icon type="close-circle" class="file-remove" @click.stop="removeFileFromMaterial(index, fi)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(form, index) in formList" :key="'formList-' + index">
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <span>状态 </span>
                <a-select v-model="form.state" style="width: 85%">
                  <a-select-option value="正常"> 正常</a-select-option>
                  <a-select-option value="异常"> 异常</a-select-option>
                </a-select>
                <a-button
                    style="margin-left: 10px"
                    size="small"
                    @click="removeFormItem1(index)"
                    v-show="formList.length >= 1"
                >
                  <a-icon type="minus"/>
                </a-button>
              </div>
              名称
              <a-auto-complete
                  v-model="form.product_name"
                  style="width: 85%; margin: 20px 0"
                  :dataSource="materialNameOptions"
                  placeholder="请选择或输入原料名称"
                  :filterOption="filterMaterialOption"
              />
              <br/>
              重量
              <a-input v-model="form.weight" style="width: 66%; margin-right: 2%"/>
              <a-select
                      v-model="form.unit"
                      style="width: 25%"
                      placeholder="单位"
              >
                <a-select-option value="g">g</a-select-option>
                <a-select-option value="kg">kg</a-select-option>
                <a-select-option value="吨">吨</a-select-option>
              </a-select>
              <br/>
              批次
              <a-input
                  v-model="form.material_batch"
                  style="width: 85%; margin: 20px 0"
              />
              <div style="display: flex; justify-content: left; margin-bottom: 20px;">
                <span style="display: block; width: 18%">检验报告 </span>
                <div style="flex: 1">
                  <a-upload
                      accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                      :action="uploadUrl"
                      :headers="uploadHeaders"
                      :maxCount="5"
                      list-type="picture-card"
                      :file-list="form.report_img"
                      :before-upload="beforeUploadFile"
                      @change="(fl) => handleChange1(fl, index)"
                      name="file"
                      :showUploadList="false"
                  >
                    <div v-if="!form.report_img || form.report_img.length < 5">
                      <a-icon type="plus"/>
                      <div class="ant-upload-text"></div>
                    </div>
                  </a-upload>
                  <!-- 自定义卡片列表 -->
                  <div class="file-card-list">
                    <div
                        v-for="(file, fi) in (form.report_img || [])"
                        :key="file.uid || fi"
                        class="file-card"
                        @click="handlePreview(file)"
                    >
                      <img v-if="isImageFile(file.name || file.url || '')" :src="file.url || file.thumbUrl || (file.response && file.response.data && file.response.data.file_url)" class="file-thumb" />
                      <div v-else class="file-icon-wrap"><span class="file-ext-icon">{{ getExtLabel(file) }}</span></div>
                      <span class="file-badge" :class="getFileBadgeClass(file)">{{ getFileBadgeText(file) }}</span>
                      <div class="file-name">{{ getFileDisplayName(file) }}</div>
                      <a-icon type="close-circle" class="file-remove" @click.stop="removeFileFromFormList(index, fi)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item prop="start" label="混合起始时间">
            <a-date-picker
                v-model="form.start"
                show-time
                placeholder="混合起始时间"
            />
          </a-form-model-item>
          <a-form-model-item prop="end" label="混合结束时间">
            <a-date-picker
                v-model="form.end"
                show-time
                placeholder="混合结束时间"
            />
          </a-form-model-item>
          <a-form-model-item prop="situation" label="混合均匀情况">
            <a-input v-model="form.situation"/>
          </a-form-model-item>
          <div>
            <a-button
                type="primary"
                @click="addNewForm1"
                style="margin-bottom: 20px"
            >新增抽样产品净含量
            </a-button
            >
            <div v-for="(form, index) in weightList" :key="'weight-' + index">
              抽样产品净含量{{ index + 1 }}
              <a-input
                  v-model="form.weight"
                  style="width: 68%; margin-bottom: 20px"
              />
              <a-button
                  style="float: right"
                  size="small"
                  @click="removeFormItem(index)"
                  v-show="weightList.length >= 1"
              >
                <a-icon type="minus"/>
              </a-button>
            </div>
          </div>
          <a-form-model-item prop="recorder" label="记录人">
            <a-select v-model="form.recorder" style="width: 100%" placeholder="请选择记录人" allowClear>
              <a-select-option v-for="item in userList" :key="item.id" :value="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="reviewer" label="复核人">
            <a-select v-model="form.reviewer" style="width: 100%" placeholder="请选择复核人" allowClear>
              <a-select-option v-for="item in userList" :key="item.id" :value="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input type="textarea" v-model="form.remark" allowClear/>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
    <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancel"
    >
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import {formulasAdd, formulasEdit} from "@/api/produce";
import {goodsInformationList} from "@/api/goods";
import {fromProductList, tracePici} from "@/api/from";
import { userList } from "@/api/account"; // 导入获取用户列表的API
import Cookies from 'js-cookie';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const IMAGE_EXTS = ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg', '.ico', '.raw'];
const OFFICE_EXTS = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
const FILE_ICON_SVG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2340a9ff">' +
  '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
  '<polyline points="14 2 14 8 20 8" fill="white"/></svg>'
);
function isImageFile(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return IMAGE_EXTS.some(ext => lower.endsWith(ext));
}
function isOfficeFile(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return OFFICE_EXTS.some(ext => lower.endsWith(ext));
}

export default {
  name: "FormModal",
  props: ["visible", "form", "formList2", "clientsClassificationOptions"],
  model: {prop: "visible", event: "cancel"},
  data() {
    return {
      internalVisible: this.visible,
      userList: [], // 用户列表
      previewImage: "",
      titleList: [
        {label: '原料索证齐全', value: '原料索证齐全'},
        {label: '原料验收合格', value: '原料验收合格'}
      ],
      titleList1: [
        {label: '根据订单生产', value: '根据订单生产'}
      ],
      uploadUrl: process.env.VUE_APP_NEW_URL + "/comapi/UploadApi",
      productCount: 0,
      productCount1: 0,
      previewVisible: false,
      productList1: [],
      materialArr: [],
      formList: [],
      formList1: [],
      weightList: [],
      batchList: [],
      /**用中间数组来中转fileList */
      fileList: [],
      levelOptions: [
        {id: "0", name: "0"},
        {id: "1", name: "1"},
        {id: "2", name: "2"},
        {id: "3", name: "3"},
      ],
      productList: [],
      rules: {
        product_id: [
          {required: true, message: "请选择产品名称", trigger: "change"},
        ],
        batch: [{required: true, message: "请选择批次", trigger: "change"}],
        number: [{required: true, message: "请输入编号", trigger: "blur"}]
      },
      loading: false,      // 产品搜索相关
      allLoadedProducts: [],
      productTotalCount: 0,
      hasMoreProducts: true,
      isLoadingMoreProducts: false,
      productSearchKeyword: '',
      productCurrentPage: 1,
      productPageSize: 50,    };
  },
  computed: {
    uploadHeaders() {
      const token = Cookies.get('access');
      return token ? { Authorization: 'Bearer ' + token } : {};
    },
    modalVisible: {
      get() {
        return this.internalVisible;
      },
      set(val) {
        this.internalVisible = val;
        if (!val) {
          this.$emit("cancel", false);
        }
      }
    },
    filteredProductList() {
      let list = this.allLoadedProducts;
      if (this.productSearchKeyword) {
        const keyword = this.productSearchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameStr = (item.product_name || '').toLowerCase();
          const idStr = String(item.goods?.id || '').toLowerCase();
          return nameStr.includes(keyword) || idStr.includes(keyword);
        });
      }
      return list;
    },
    materialNameOptions() {
      // 从关联原料中提取名称作为选项
      if (!this.form.material || this.form.material.length === 0) {
        return [];
      }
      return this.form.material
        .map(item => item.product_name)
        .filter(name => name && name.trim());
    }
  },
  watch: {
    visible(newVal) {
      this.internalVisible = newVal;
    },
    "form.net_content": {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          let arr = [];
          newVal.forEach((item) => {
            arr.push({
              weight: item,
            });
          });
          this.weightList = arr;
        }
      },
      deep: true,
    }
  },
  created() {
    // 确保 form.others 是响应式对象，且包含 describe_y / describe_s
    if (!this.form.others || typeof this.form.others !== 'object') {
      this.$set(this.form, 'others', { describe_y: [], describe_s: [] });
    } else {
      if (!this.form.others.describe_y) this.$set(this.form.others, 'describe_y', []);
      if (!this.form.others.describe_s) this.$set(this.form.others, 'describe_s', []);
    }
    // 获取用户列表
    userList({ page_size: 999999 }).then(res => {
      this.userList = res.results || [];
    });
    this.formList = this.formList2
    this.productList1 = [];
    this.productCount1 = 0;
    const pageSize = 999999;
    const endIf = () => this.productList1.length >= this.productCount1;
    const loopLoad = (page, end) => {
      return goodsInformationList({page, page_size: pageSize}).then((res) => {
        this.productCount1 = res.count || this.productCount1;
        this.productList1.push(...res.results);
        if (!end()) {
          return loopLoad(page + 1, end);
        }
      });
    };
    loopLoad(1, endIf);
    
    // 加载产品列表（用于搜索）
    this.loadMoreProducts(false);
    console.log(this.form);
    /**初始化fileList的数据 */
    if (this.form && this.form.material) {
      let material = this.form.material;
      // 后端存储的是 JSON 字符串，需要先解析
      if (typeof material === 'string') {
        try { material = JSON.parse(material); } catch (e) { material = []; }
        this.form.material = material;
      }
      if (Array.isArray(material)) {
        material.forEach((node, index) => {
          if (node.report_img) {
            // report_img 可能是 URL 字符串数组，也可能已经是 fileList 对象数组
            if (Array.isArray(node.report_img) && node.report_img.length > 0 && typeof node.report_img[0] === 'string') {
              node.report_img = node.report_img.map((item, i) => {
                const n = item.split("/");
                return {
                  uid: index + '-' + i,
                  name: n[n.length - 1],
                  status: "done",
                  url: item,
                };
              });
            } else if (!Array.isArray(node.report_img)) {
              node.report_img = [];
            }
          } else {
            node.report_img = [];
          }
        });
      }
    }
  },
  methods: {
    isImageFile,
    handleCancel() {
      this.previewVisible = false;
    },
    onRefresh() {
      this.$forceUpdate();
    },
    beforeUploadFile(file) {
      if (!isImageFile(file.name)) {
        file.thumbUrl = FILE_ICON_SVG;
      }
      return true;
    },
    async handlePreview(file) {
      const name = file.name || file.url || '';
      const url = file.url || (file.response && file.response.data && file.response.data.file_url) || '';
      if (!isImageFile(name)) {
        if (!url) return;
        if (isOfficeFile(name)) {
          try {
            const res = await fetch(url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = name.split('/').pop() || 'file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
          } catch (e) {
            window.open(url, '_blank');
          }
        } else {
          window.open(url, '_blank');
        }
        return;
      }
      if (!file.url && !file.preview) {
        if (file.originFileObj instanceof Blob) {
          file.preview = await getBase64(file.originFileObj);
        } else if (file.response && file.response.data && file.response.data.file_url) {
          file.preview = file.response.data.file_url;
        } else {
          return;
        }
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({fileList}, index) {
      this.$set(this.form.material[index], "report_img", fileList);
      this.$forceUpdate();

    },
    handleChange1({fileList}, index) {
      this.$set(this.formList[index], "report_img", fileList);
      this.$forceUpdate();
    },
    // ── 自定义卡片辅助方法 ──────────────────────────────────
    getExtLabel(file) {
      const name = file.name || file.url || '';
      const m = name.toLowerCase().match(/\.[^.]+$/);
      return m ? m[0].replace('.', '').toUpperCase() : 'FILE';
    },
    getFileDisplayName(file) {
      const name = file.name || file.url || '';
      return name.split('/').pop() || name;
    },
    getFileBadgeText(file) {
      const name = file.name || file.url || '';
      if (isImageFile(name)) return '预览';
      const lower = name.toLowerCase();
      if (lower.endsWith('.pdf') || lower.endsWith('.txt')) return '新窗口';
      return '下载';
    },
    getFileBadgeClass(file) {
      const name = file.name || file.url || '';
      if (isImageFile(name)) return 'badge-image';
      const lower = name.toLowerCase();
      if (lower.endsWith('.pdf') || lower.endsWith('.txt')) return 'badge-preview';
      return 'badge-download';
    },
    removeFileFromMaterial(itemIndex, fileIndex) {
      const list = (this.form.material[itemIndex].report_img || []).filter((_, i) => i !== fileIndex);
      this.$set(this.form.material[itemIndex], 'report_img', list);
      this.$forceUpdate();
    },
    removeFileFromFormList(itemIndex, fileIndex) {
      const list = (this.formList[itemIndex].report_img || []).filter((_, i) => i !== fileIndex);
      this.$set(this.formList[itemIndex], 'report_img', list);
      this.$forceUpdate();
    },
    removeFormItem(index) {
      this.weightList.splice(index, 1);
    },
    removeFormItem1(index) {
      this.formList.splice(index, 1);
    },
    removeFormItem2(index) {
      this.form.material.splice(index, 1);
      this.$forceUpdate();
    },
    addNewForm() {
      this.formList.push({
        state: "正常",
        product_name: "",
        weight: "",
        material_batch: "",
        report_img: [],
      }); // 在表单数组中新增一个空字段
    },
    addNewForm1() {
      this.weightList.push({weight: ""});
    },
    // ===== 产品搜索相关方法 =====
    loadMoreProducts(isLoadMore = false) {
      if (!isLoadMore) {
        this.productCurrentPage = 1;
        this.allLoadedProducts = [];
      }
      this.isLoadingMoreProducts = true;
      fromProductList({ page: this.productCurrentPage, page_size: this.productPageSize }).then(res => {
        const newList = res.data || [];
        this.productTotalCount = res.count || 0;
        if (isLoadMore) {
          this.allLoadedProducts = [...this.allLoadedProducts, ...newList];
        } else {
          this.allLoadedProducts = newList;
        }
        this.hasMoreProducts = this.allLoadedProducts.length < this.productTotalCount;
      }).finally(() => {
        this.isLoadingMoreProducts = false;
      });
    },
    handleProductSearch(value) {
      this.productSearchKeyword = value;
    },
    handleProductPopupScroll(e) {
      const { target } = e;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;
      if (scrollHeight - scrollTop <= clientHeight + 10 && this.hasMoreProducts && !this.isLoadingMoreProducts) {
        this.productCurrentPage++;
        this.loadMoreProducts(true);
      }
    },
    filterMaterialOption(inputValue, option) {
      const text = option && option.componentOptions && option.componentOptions.children
        ? option.componentOptions.children[0].text
        : (typeof option === 'string' ? option : '')
      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
    },
    onChange(val) {
      this.batchList = [];
      delete this.form.batch;
      // 从 allLoadedProducts 中查找选中的产品
      this.materialArr = [];
      this.allLoadedProducts.forEach((item) => {
        if (item.goods.id == val) {
          this.materialArr = item.goods && item.goods.association;
        }
      });
      let arr = [];
      this.materialArr &&
      this.materialArr.forEach((item) => {
        let info = "";
        this.productList1.forEach((node) => {
          if (node.id == item) {
            info = node.name;
          }
        });
        arr.push({
          state: "正常",
          product_name: info,
          weight: "",
          material_batch: "",
          report_img: [],
        });
      });
      this.form.material = arr;
      // 只在没有关联原料且formList为空时，才添加一个空白输入框
      if (arr && arr.length === 0 && this.formList.length === 0) {
        this.formList.push({
          state: "正常",
          product_name: "",
          weight: "",
          material_batch: "",
          report_img: [],
        });
      }
      // 保留用户输入的自定义原料，不清空 formList
      this.batchListInfo(val, 0);
    },
    async batchListInfo(id) {
      let res1 = await tracePici({product_id: id});
      this.batchList = res1.data;
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 确保 material 是数组（防止后端返回 JSON 字符串未被初始化）
          let material = this.form.material;
          if (typeof material === 'string') {
            try { material = JSON.parse(material); } catch (e) { material = []; }
          }
          if (!Array.isArray(material)) material = [];
          // 构建提交 payload，不修改 this.form.material（避免 a-upload fileList 校验报错）
          const materialPayload = this.formList.concat(material).map((item) => ({
            ...item,
            report_img: (item.report_img || [])
              .filter((f) => f.status === "done")
              .map((f) => (f.url || (f.response && f.response.data && f.response.data.file_url)))
              .filter(Boolean),
          }));
          let arr = [];
          this.weightList.forEach((item) => {
            arr.push(item.weight);
          });
          const payload = {
            ...this.form,
            material: materialPayload,
            net_content: arr,
            start: this.form.start && moment(this.form.start).format('YYYY-MM-DD HH:mm:ss').replace(' ', 'T'),
            end: this.form.end && moment(this.form.end).format('YYYY-MM-DD HH:mm:ss').replace(' ', 'T'),
          };
          let func = this.form.id ? formulasEdit : formulasAdd;
          func(payload)
              .then((res) => {
                if (res.code !== 200) {
                  this.$message.warn(res.message)
                } else {
                  this.$message.success(this.form.id ? "修改成功" : "新增成功");
                  this.$emit(this.form.id ? "update" : "create");
                  this.cancel();
                }
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      this.formList = [];
      this.weightList = [];
      if (!this.form.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style scoped>
/* 隐藏 picture-card 模式下的默认列表（用自定义卡片替代） */
:deep(.ant-upload-list-picture-card) { display: none; }

.file-card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.file-card {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  cursor: pointer;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;
}
.file-card:hover { border-color: #1890ff; }
.file-thumb {
  width: 100%;
  height: 60px;
  object-fit: cover;
}
.file-icon-wrap {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f7ff;
}
.file-ext-icon {
  font-size: 16px;
  font-weight: bold;
  color: #1890ff;
  letter-spacing: -1px;
}
.file-name {
  width: 100%;
  padding: 2px 4px;
  font-size: 10px;
  color: #555;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  height: 28px;
  line-height: 24px;
}
.file-badge {
  position: absolute;
  top: 3px;
  left: 3px;
  font-size: 9px;
  padding: 1px 4px;
  border-radius: 3px;
  color: #fff;
  line-height: 16px;
}
.badge-image    { background: #52c41a; }
.badge-preview  { background: #1890ff; }
.badge-download { background: #fa8c16; }
.file-remove {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 14px;
  color: rgba(0,0,0,0.45);
  background: rgba(255,255,255,0.8);
  border-radius: 50%;
  display: none;
}
.file-card:hover .file-remove { display: block; }
.file-remove:hover { color: #ff4d4f; }
</style>
